/**
 * 竞价实时信息大屏显示
 */
import React from 'react';
import "./AuctionedTable.css";
import "./HeadBanner.css";
import http from '../../../axios/http';
import moment from 'moment';
import logoImg from "./img/logo.png";
import completeImg from "./img/complete.png";
import "../../../style/ui/icon.css";
import { getUrlParam } from '../../../util/util';
import waitBeginImg from "./img/waitBegin.png";
import auctionIngImg from "./img/auctioning.png";
import backgroundImg from "./img/background1.jpg";

import AuctionItem from "./AuctionItem.jsx";

const weekMap = {
    "1": "一",
    "2": "二",
    "3": "三",
    "4": "四",
    "5": "五",
    "6": "六",
    "0": "日",
}

class AuctionedTable extends React.Component {
    state = {
        data: [],
        currentId: '',
        sessionList: [], //场次列表
        lots: [], //竞品
        sessionId:"",
    }

    componentDidMount() {
        //初始化时间
        let now = new moment();
        let time = now.format("H:mm:ss");
        let date = now.format("YYYY-MM-DD ");
        let day = now.day() + "";
        this.isUnmount = false;
        let sessionId = getUrlParam("sessionId");
        this.getSession(sessionId);
        this.setState({
            time: time,
            date: date + "星期" + weekMap[day],
            sessionId:sessionId
        });
        //设置右上角的时间
        this.initTime();
        this.timerID = setInterval(() => this.initTime(), 1000);
    }
    initTime = () => {
        let now = new moment();
        let time = now.format("H:mm:ss");
        let date = now.format("YYYY-MM-DD ");
        let day = now.day() + "";
        this.setState({
            time: time,
            date: date + "星期" + weekMap[day]
        });
    }

    componentWillUnmount() {
        this.isUnmount = true;
        clearInterval(this.timerID);
    }

    lotsDetail = (data,lotIndex) => {
        let sessionId = this.state.sessionId;
        let session = this.state.session;
        
        http.get({
            url: '/auction/largescreen/auctionTask?sessionId=' + sessionId,
            success: (res) => {
                //除了已结束其他状态都进入倒计时
                if(session.status ===2){
                    let url = window.location.origin + "/large/lotsDetail/" + data.id;
                    window.open(url, "lotsDetail");
                }else{
                    let url = window.location.origin + "/large/auctioning?sessionId=" + sessionId + "&lotsId=" + data.id;
                    window.open(url, "auctioning");
                }
            }
        });
    }

    // 获取场次列表 
    getSession = (sessionId) => {
        http.get({
            url: '/auction/largescreen/findSession',
            data: { sessionId: sessionId },
            success: (res) => {
                if (res) {
                    let doms = [];
                    let lots = res.lots;
                    lots.forEach((item, index) => {
                        let center = false;
                        if (index % 4 === 1 || index % 4 === 2) {
                            center = true;
                        }
                        let startTime = res.startTime;
                        doms.push((<AuctionItem key={index} item={item} lotsDetail={this.lotsDetail.bind(this,item,index)} center={center} startTime={startTime} />));
                        this.setState({
                            session: res,
                            currentId: res.id,
                            lots: lots,
                            doms: doms
                        })
                    })
                }
            }
        })
    }

    render() {
        const session = this.state.session;
        if (!session) {
            return (<div></div>)
        }
        else {
            const status = session.status;
            return (
                <div className="root" style={{ background: 'url(' + backgroundImg + ') no-repeat', backgroundSize: 'cover' }}>
                    <div className="head" style={{ textAlign: 'center' }}>
                        <div className="head-container">
                            <div className='head-left head-div'>
                                <img className="head-logo-img" src={logoImg} alt="logo" />
                                <div className="head-logo-text">厦门二手车交易市场网上竞价大厅</div>
                            </div>
                            <div className='head-center head-div'>
                                <img className="head-status-img" src={status === 0 ? waitBeginImg : (status === 1 ? auctionIngImg : completeImg)} alt="status" />
                            </div>
                            <div className='head-right head-div'>
                                <span className="head-right-time">{this.state.time}</span><br />
                                <span className="head-right-date">{this.state.date}</span>
                            </div>
                        </div>
                    </div>
                    <div className='main-container'>
                        <div className="main" style={{ margin: "2vw auto 0" }}>
                            <div className='auction-item-container' style={{ width: "100%", marginLeft: 0 }}>
                                {this.state.doms}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}
export default AuctionedTable;